// src/pages/FriendsgivingQuiz.js
import React, { useState } from 'react';
import './Friendsgiving.css'; // reuse the styles you already have

const questions = [
  {
    question: "What should the theme be?",
    options: [
      "Mythical creatures",
      "Wear something you have nowhere to wear it to",
      "Pajamas",
      "PINK!!!!! (not the artist)",
      "Soviet satellites",
      "Themes are lame",
      "Outer space"
    ],
  },
  {
    question: "What will you bring?",
    options: [
      "Cake",
      "Wine",
      "Chips",
      "Vodka",
      "Chase",
      "Nothing",
      "A bike"
    ],
  },
  {
    question: "What time will you come?",
    options: [
      "7 pm when it starts",
      "8 pm I have class",
      "9 pm or later",
      "6 to help you set up and get an early start on the wine",
      "I’m not coming at any time"
    ],
  },
  {
    question: "What is a fun little day for this?",
    options: [
      "A Monday",
      "A Tuesday",
      "A Wednesday",
      "A Thursday",
      "A Friday",
      "A Saturday",
      "A Sunday"
    ],
  },
  {
    question: "Do you want to be part of the planning committee?",
    options: [
      "Yes",
      "No"
    ],
  },
  {
    question: "Should we go to bars after?",
    options: [
      "Yes",
      "No let's bike on campus after"
    ],
  },
];

const FINAL_MESSAGE = "you’re obviously coming — matter of fact, call me right now and RSVP ✨";

export default function FriendsgivingQuiz() {
  const [currentQ, setCurrentQ] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = () => {
    const next = currentQ + 1;
    if (next < questions.length) setCurrentQ(next);
    else setShowResult(true);
  };

  const restart = () => {
    setCurrentQ(0);
    setShowResult(false);
  };

  return (
    <div className="friendsgivingquiz-page">
    <div className="quiz-container">
      <h1 className="quiz-title">22nd Birthday Survey</h1>

      {showResult ? (
        <div className="result">
          <h2 className="result-title">{FINAL_MESSAGE}</h2>
          <button className="option-btn" onClick={restart}>Restart</button>
        </div>
      ) : (
        <>
          <h2 className="question">{questions[currentQ].question}</h2>
          <div className="options">
            {questions[currentQ].options.map((opt, i) => (
              <button className="option-btn" key={i} onClick={handleAnswer}>
                {opt}
              </button>
            ))}
          </div>
          <div className="progress" aria-live="polite">
            Question {currentQ + 1} of {questions.length}
          </div>
        </>
      )}
    </div>
    </div>
  );
}
